module.exports = __webpack_public_path__ + "lp/img/camera_icn-on@2x.caef614c.png";